import React, { useRef, useEffect } from 'react';
import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';

interface TextEditorProps {
  value: string;
  onChange: (content: string) => void;
  height?: string;
}

const TextEditor: React.FC<TextEditorProps> = ({
  value,
  onChange,
  height = '200px',
}) => {
  const quillRef = useRef<ReactQuill>(null);

  useEffect(() => {
    const quill = quillRef.current;
    if (quill) {
      const editor = quill.getEditor();
      const toolbar = editor.getModule('toolbar');

      if (toolbar) {
        // 링크 버튼 커스터마이징
        const linkButton = toolbar.container.querySelector('.ql-link');
        if (linkButton) {
          // 기존 이벤트 리스너가 중복 등록되지 않도록 제거 후 추가
          linkButton.onclick = () => {
            const selection = editor.getSelection();
            if (selection) {
              const url = prompt("링크 주소를 입력하세요:");

              if (url) {
                // 선택된 텍스트가 없으면 URL 자체를 텍스트로 삽입
                if (selection.length === 0) {
                  editor.insertText(selection.index, url, 'user');
                  editor.formatText(selection.index, url.length, 'link', url);
                  editor.setSelection({ index: selection.index + url.length, length: 0 });
                } else {
                  // 선택된 텍스트가 있으면 해당 텍스트에 링크 적용
                  editor.format('link', url);
                }
              }
            }
          };
        }
      }
    }
  }, []);

  const modules = {
    toolbar: {
      container: [
        [{ header: '1' }, { header: '2' }, { font: [] }],
        [{ size: [] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ color: [] }, { background: [] }],
        ['link', 'image', 'video'],
        ['clean'],
      ],
    },
  };

  const formats = [
    'header',
    'font',
    'size',
    'bold',
    'italic',
    'underline',
    'strike',
    'color',
    'background',
    'link',
    'image',
    'video',
  ];

  return (
    <div className="mb-6">
      <ReactQuill
        ref={quillRef}
        value={value}
        onChange={onChange}
        modules={modules}
        formats={formats}
        style={{ height }}
      />
    </div>
  );
};

export default TextEditor;
